
import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";
import Swal from 'sweetalert2';

const LISTADO = 'LISTADO';
const LOADER = 'LOADER';
const MODULO = 'MODULO';
const PARAMETRO = 'PARAMETRO';
const DETALLE = 'DETALLE';
const DETALLE_ORDEN = 'DETALLE_ORDEN';
const CLIENTE = 'CLIENTE';
const TIPO_CAMBIO = 'TIPO_CAMBIO';
const LISTADO_TIPOS = 'LISTADO_TIPOS';
const LISTADO_ACTIVIDADES = 'LISTADO_ACTIVIDADES';
const LISTADO_COLABORADORES = 'LISTADO_COLABORADORES';

const setLoader = loader => ({
    type: LOADER,
    loader,
});


export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    
    const params = { id };
    dispatch(setLoader(true));
    api.get('/mano_obra', params).then((response) => {
        dispatch({ type: LISTADO, data: response });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al listar mano de obra',
            'Error',
            3000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}


export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        if (error.status === 401){
            NotificationManager.error(
              error.body.msj,
              'Error',
              0
            );
        }
        if (error.status === 400){
            NotificationManager.error(
              'Ocurrió un error en buscar modulo',
              'Error',
              0
            );
        }
    }).finally(() => {
        dispatch(setLoader(false));
    });
};


export const parametrosEmpresa = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = { id }
    dispatch(setLoader(true));
    api.get('/empresa/empresa_parametros', params).then((response) => {
        dispatch({ type: PARAMETRO, datos: response });
    }).catch((error) => {

        NotificationManager.error(
            'Ocurrió un error al consultar parametros',
            'Error',
            8000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}


export const listarPresupuestos = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id, search}
    return api.get('/presupuesto/proyectos',params).then(data=>{
        const list_presupuestos = [];
        if(data){
            data.forEach(item=>{
                list_presupuestos.push({
                    value: item.id,
                    label: item.nombreProyecto
                })
            })
        }
        return list_presupuestos;
    }).catch((error)=>{
        
        return [];
    })
}


export const agregarLinea = (tipoCambio, cantidadPersonas, cantidadHorasHombre, totalQ, cantHorasSimple, cantHorasDoble, tipoEmp, valorPrest) => (dispatch, getStore) => {
    const data = getStore().form.FormManoObra.values;
    if (data === undefined || data === null) {
        Swal.fire({
            title: 'Mano de obra',
            text: 'Debe de ingresar clasificación',
            type: 'error',
        })
    } else {
        if (data.tipo_mdo === undefined || data.tipo_mdo === null) {
            Swal.fire({
                title: 'Mano de obra',
                text: 'Debe de seleccionar tipo mano de obra',
                type: 'error',
            })
        } else {
            if (data.horas_hombre_ordinarias === undefined || data.horas_hombre_ordinarias === 0.00) {
                Swal.fire({
                    title: 'Mano de obra',
                    text: 'Debe de ingresar cantidad horas hombre ordinarias',
                    type: 'error',
                })
            } else {
                const detalleActual = data.detalleD || [];
                let tipo_mano = data.tipo_mdo.label;
                let tipo_mano_id = data.tipo_mdo.value.split('#');
                let prestacion = 0.00;
                let horasSimples = parseFloat((parseFloat(totalQ) /30 /8 * 1.5) * parseFloat(cantHorasSimple)).toFixed(2);
                let horasDobles = parseFloat((parseFloat(totalQ) /30 /8 * 2) * parseFloat(cantHorasDoble)).toFixed(2);
                let tot = parseFloat((parseFloat(totalQ) /30 /8) * parseFloat(cantidadHorasHombre)).toFixed(2);
                let granTotal = parseFloat(parseFloat(tot) + parseFloat(horasSimples) + parseFloat(horasDobles)).toFixed(2);
                let montoQ = parseFloat(parseFloat(granTotal) * parseFloat(cantidadPersonas)).toFixed(2);
                let montoD = parseFloat(parseFloat(montoQ) / parseFloat(tipoCambio)).toFixed(2);
                let colaborador = data.colaborador.value.split('#')
                if (tipoEmp === 'CO') {
                    prestacion = parseFloat(parseFloat(montoQ) * parseFloat(valorPrest)).toFixed(2);
                }
                const nuevoDetalle = [
                    ...detalleActual,
                    {
                        id: Date.now(),
                        tipo_mano_obra: tipo_mano,
                        tipo_mano_obra_id: tipo_mano_id[0],
                        tipo: data.tipo,
                        actividad_id: data.actividad.value,
                        cantidad_personas: 1,
                        cantidad_horas_hombre: data.horas_hombre_ordinarias,
                        cantidad_horas_simples: parseFloat(cantHorasSimple),
                        cantidad_horas_dobles: parseFloat(cantHorasDoble),
                        prestaciones: parseFloat(prestacion),
                        monto_mensual: totalQ,
                        totalQ: montoQ,
                        totalD: montoD,
                        id_colaborador: colaborador[0],
                        nombre: colaborador[2].trim()
                    }
                ];
                data.cantidad_personas = 0;
                data.horas_hombre_ordinarias = 0.00;
                data.horas_hombre_simples = 0.00;
                data.horas_hombre_dobles = 0.00;
                data.monto_q = 0.00;
                data.detalleD = nuevoDetalle;
                
                NotificationManager.success(
                    'Mano de obra ingresada correctamente',
                    'Exito',
                    3000
                );
                dispatch(actualizar());
            }
        }
    }
}

const actualizar = () => (dispatch, getStore) => {
    const data = getStore().form.FormManoObra.values;
    dispatch(initializeForm('FormManoObra', {
        ...data,
        tipo_mdo: null,
        colaborador: null
    }));
    dispatch({ type: DETALLE, detalleOrden: data.detalleD })
};

const limpiarManoObra = () => (dispatch) => {
    dispatch({ type: DETALLE, detalleOrden: [] })
    dispatch({ type: CLIENTE, clienteProyecto: '' })
    dispatch({ type: TIPO_CAMBIO, cambioD: 0.000000 })
};


export const registroManoObra = (detalleO, cambioD) => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormManoObra.values;
    if (data.proyecto === undefined || data.proyecto === null) {
        Swal.fire({
            title: 'Mano de obra',
            text: 'Debe de seleccionar un proyecto',
            type: 'error',
        })
    } else {
        if (detalleO.length === 0) {
            Swal.fire({
                title: 'Mano de obra',
                text: 'Debe de ingresar detalle de presupuesto',
                type: 'error',
                })
        } else {
            const formData = {
                proyecto: data.proyecto.value,
                tipo_cambio: cambioD,
                observaciones: data.observaciones,
                detalleManoObra: data.detalleD,
                empresa: id_emp[5],
            }
            dispatch(setLoader(true));
            api.post('/mano_obra/', formData).then(() => {
                NotificationManager.success(
                    'Mano de obra guardado correctamente',
                    'Exito',
                    3000
                );
                let ruta = `/gestion_proyecto/${id_emp[5]}/mano_obra`;
                dispatch(push(ruta));
            }).catch((error) => {
                NotificationManager.error(
                    error.msj,
                    'Error',
                    0
                );
            }).finally(() => {
                dispatch(setLoader(false));
            });
        }
    }
}

const leerDetalleManoObra = id => (dispatch) => {
    api.get(`/mano_obra_detalle/${id}`).then((response) => {
        dispatch({ type: DETALLE_ORDEN, detalleOrd: response });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error',
            'Error',
            0
        );
    })
};

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/mano_obra/${id}`).then((response) => {
        dispatch(leerDetalleManoObra(response.id));
        dispatch({type: TIPO_CAMBIO, cambioD: response.tipo_cambio})
        dispatch(initializeForm('FormManoObra', response));
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al consultar mano de obra',
            'Error',
            3000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

const eliminarLinea = (id) => (dispatch, getStore) => {
    const data = getStore().form.FormManoObra.values;
    const nuevoDetalle = data.detalleD.filter(element => element.id !== id);
    dispatch(initializeForm('FormManoObra', {
        ...data,
        detalleD: nuevoDetalle,
        tipo_mdo: null,
    }));
    dispatch({ type: DETALLE, detalleOrden: nuevoDetalle })
};

export const agregarLineaNueva = (tipoCambio, cantidadPersonas, cantidadHorasHombre, totalQ, cantHorasSimple, cantHorasDoble, tipoEmp, valorPrest) => (dispatch, getStore) => {
    const data = getStore().form.FormManoObra.values;
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    if (data === undefined || data === null) {
        Swal.fire({
            title: 'Mano de obra',
            text: 'Debe de ingresar clasificación',
            type: 'error',
        })
    } else {
        if (data.tipo_mdo === undefined || data.tipo_mdo === null) {
            Swal.fire({
                title: 'Mano de obra',
                text: 'Debe de seleccionar tipo mano de obra',
                type: 'error',
            })
        } else {
            if (data.horas_hombre_ordinarias === undefined || data.horas_hombre_ordinarias === 0.00) {
                Swal.fire({
                    title: 'Mano de obra',
                    text: 'Debe de ingresar cantidad horas hombre ordinarias',
                    type: 'error',
                })
            } else {
                let tipo_mano_id = data.tipo_mdo.value.split('#');
                let prestacion = 0.00
                let horasSimples = parseFloat((parseFloat(totalQ) /30 /8 * 1.5) * parseFloat(cantHorasSimple)).toFixed(2);
                let horasDobles = parseFloat((parseFloat(totalQ) /30 /8 * 2) * parseFloat(cantHorasDoble)).toFixed(2);
                let tot = parseFloat((parseFloat(totalQ) /30 /8) * parseFloat(cantidadHorasHombre)).toFixed(2);
                let granTotal = parseFloat(parseFloat(tot) + parseFloat(horasSimples) + parseFloat(horasDobles)).toFixed(2);
                let montoQ = parseFloat(parseFloat(granTotal) * parseFloat(cantidadPersonas)).toFixed(2);
                let montoD = parseFloat(parseFloat(montoQ) / parseFloat(tipoCambio)).toFixed(2);
                let colaborador = data.colaborador.value.split('#')
                if (tipoEmp === 'CO') {
                    prestacion = parseFloat(parseFloat(montoQ) * parseFloat(valorPrest)).toFixed(2);
                }

                const formData = {
                    tipo_mano_obra_id: tipo_mano_id[0],
                    tipo: data.tipo,
                    actividad_id: data.actividad.value,
                    cantidad_personas: 1,
                    cantidad_horas_hombre: data.horas_hombre_ordinarias,
                    cantidad_horas_simples: parseFloat(cantHorasSimple),
                    cantidad_horas_dobles: parseFloat(cantHorasDoble),
                    prestaciones: parseFloat(prestacion),
                    monto_mensual: totalQ,
                    totalQ: montoQ,
                    totalD: montoD,
                    id_colaborador: colaborador[0],
                    id: id_emp[7],
                }
                dispatch(setLoader(true));
                api.post('/mano_obra_detalle/', formData).then((response) => {
                    data.tipo_mdo = null;
                    data.cantidad_personas = 0;
                    data.horas_hombre_ordinarias = 0.00;
                    data.horas_hombre_simples = 0.00;
                    data.horas_hombre_dobles = 0.00;
                    data.monto_q = 0.00;
                    dispatch(leerDetalleManoObra(response.id));
                    NotificationManager.success(
                        'Mano de obra ingresada correctamente',
                        'Exito',
                        3000
                    );
                }).catch((error) => {
                    NotificationManager.error(
                        error.msj,
                        'Error',
                        0
                    );
                }).finally(() => {
                    dispatch(setLoader(false));
                });
            }
        }
    }
}

export const modificarManoObra = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormManoObra.values;
    let id = id_emp[7]
    
    let proyecto= data.proyecto_mod;
    if (proyecto === undefined){
        proyecto = data.proyecto;
    }else{
        proyecto = data.proyecto_mod.value;
    }

    const formData = {
        id: id,
        observaciones: data.observaciones,
        proyecto: proyecto
    }
    dispatch(setLoader(true));
    api.put(`/mano_obra/${id}/`, formData).then(() => {
        NotificationManager.success(
            'Mano de obra modificado correctamente',
            'Exito',
            3000
        );

        let ruta = `/gestion_proyecto/${id_emp[5]}/mano_obra`
        dispatch(push(ruta));
    }).catch((error) => {
        NotificationManager.error(
            error.msj,
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

const eliminarLineaManoObra = id => (dispatch) => {
    let ruta = window.location.href.split('/');
    let id_emp = ruta[7];
    dispatch(setLoader(true));
    api.eliminar(`/mano_obra_detalle/${id}`).then(() => {
        dispatch(leerDetalleManoObra(id_emp));
        NotificationManager.success(
            'Mano de obra borrada correctamente',
            'Exito',
            3000
        );
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en eliminar',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const buscarCliente = (id) => (dispatch) => {
    api.get(`/presupuesto/${id}`).then((response) => {
        dispatch({type: CLIENTE, clienteProyecto: response.nombreCliente})
        dispatch({type: TIPO_CAMBIO, cambioD: response.tipo_cambio})
    }).catch(() => {
        return [];
    })
}

export const listarTipoMO = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = { id };
    api.get('/tipo_mano_obra', params).then((response) => {
        const tipos = [];
        response.forEach(item=>{
            tipos.push({
                value: item.id,
                label: item.descripcion
            })
        })
        dispatch({ type: LISTADO_TIPOS, listaTipoMO: tipos });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al listar los proyectos',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const listarColaboradores = (id) => (dispatch) => {
    api.get(`/proyecto_colaborador_detalle/${id}`).then((response) => {
        const colaborador = [];
        response.forEach(item=>{
            colaborador.push({
                value: item.id + "#" + item.sueldo + "#" + item.nombre,
                label: item.identificador + ' -- ' + item.nombre
            })
        })
        dispatch({ type: LISTADO_COLABORADORES, listaColaborador: colaborador});
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al listar los proyectos',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const listarActividad = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = { id };
    api.get('/actividad_mano_obra', params).then((response) => {
        const actividades = [];
        response.forEach(item=>{
            actividades.push({
                value: item.id,
                label: item.descripcion
            })
        })
        dispatch({ type: LISTADO_ACTIVIDADES, listaActividad: actividades });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al listar los proyectos',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const actions = {
    listar,
    registroManoObra,
    modificarManoObra,
    leer,
    limpiarManoObra,
    listarPresupuestos,
    getModulo,
    parametrosEmpresa,
    agregarLinea,
    eliminarLineaManoObra,
    agregarLineaNueva,
    eliminarLinea,
    buscarCliente,
    listarTipoMO,
    listarActividad,
    listarColaboradores
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
    [PARAMETRO]: (state, { datos }) => {
        return {
            ...state,
            datos,
        };
    },
    [DETALLE]: (state, { detalleOrden }) => {
        return {
            ...state,
            detalleOrden,
        };
    },
    [DETALLE_ORDEN]: (state, { detalleOrd }) => {
        return {
            ...state,
            detalleOrd,
        };
    },
    [CLIENTE]: (state, { clienteProyecto }) => {
        return {
            ...state,
            clienteProyecto,
        };
    },
    [TIPO_CAMBIO]: (state, { cambioD }) => {
        return {
            ...state,
            cambioD,
        };
    },
    [LISTADO_TIPOS]: (state, { listaTipoMO }) => {
        return {
            ...state,
            listaTipoMO,
        };
    },
    [LISTADO_ACTIVIDADES]: (state, { listaActividad }) => {
        return {
            ...state,
            listaActividad,
        };
    },
    [LISTADO_COLABORADORES]: (state, { listaColaborador }) => {
        return {
            ...state,
            listaColaborador,
        };
    },
};

export const initialState = {
    loader: false,
    tipos: [],
    periodoS: null,
    monedas: [],
    modulo: [],
    data: [],
    detalleOrden: [],
    detalleOrd: [],
    clienteProyecto: '',
    cambioD: 0.000000,
    listaTipoMO: [],
    listaActividad: [],
    listaColaborador: []
};

export default handleActions(reducers, initialState)